var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('preview-wrapper',{staticClass:"bg-yellow-light offer-preview",attrs:{"title":_vm.offerTitle,"caption":_vm.offerCaption,"hide-icon":""},nativeOn:{"click":function($event){return _vm.openOfferTab.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }